import axios from 'axios';

/**
 * Send message deleteMessage request
 * @param {Object} options
 * @param {number} options.messageId Message id
 * @param {number} options.userId User id
 * @returns {Promise<void>}
 */
export const deleteMessage = ({ messageId, userId }) =>
    axios.delete(`/users/${userId}/pinned_flashes/${messageId}`, {
        data: {
            bomba: 'true'
        }
    });
